<script lang="ts">
  import cx from "classnames";
  import { MAIN_CONTENT_ID } from "./skiplink";

  export let label = "Skip to main content";

  /**
   * Skip link
   * This is a link that allows users to bypass sections on a page and jump straight to a section of interest.
   * It reduces the number of tab stops that keyboard users need to go through before they reach the main content of the page.
   * This component uses a hidden link that becomes visible and accessible via keyboard navigation.
   */
</script>

<a
  href={`#${MAIN_CONTENT_ID}`}
  class={cx(
    "fixed top-2 -left-[500px] z-[999] rounded-[5px] p-2 text-sm font-medium backdrop-blur-md focus:outline-none   focus-visible:ring-1  focus-visible:ring-community-primary",
    "border border-black/10 bg-white/50 text-neutral-500 shadow-sm hover:bg-black/5 hover:text-neutral-600", // light mode styles
    "dark:border-white/5 dark:bg-white/5 dark:text-neutral-300 dark:shadow dark:hover:bg-white/10 dark:hover:text-neutral-300", // dark mode styles
    "transition-[left] duration-400 ease-in-out focus-visible:left-2"
  )}>{label}</a
>
